<div class="error-page" role="alert" aria-live="assertive">
    <h1 class="error-title">Something went wrong</h1>
    <p class="error-message">{{ message }}</p>
    <div class="error-actions">
        <button matButton="filled" (click)="goHome()">Go home</button>
    </div>
</div>